import React from "react";
import { connect } from "react-redux";
import SolicitudesGrid from "./solicitudes";
import FormSolicitud from "./NuevaSolicitud/view";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { setTipoSolicitud } from "./actions";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

class Solicitudes extends React.Component {

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  shouldComponentUpdate = (nextProps) => {
    if (nextProps.isLoading !== this.props.isLoading) {
      return true;
    }
    return false;
  }

  handleSelectTipo = (tipo) => {
    this.props.dispatch(setTipoSolicitud(tipo));
  }

  render() {
    return (
      <React.Fragment>
        {this.props.isLoading && <LoadingOverlay />}
        <SolicitudesGrid />
        <FormSolicitud />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.solicitudesAgendaSel.isLoading,
  selectedTipoSolicitud: state.solicitudesAgendaSel.selectedTipoSolicitud,
  isEditTrabajadores: state.solicitudesAgendaSel.isEditTrabajadores,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Solicitudes);
